import React from 'react';
import NavLinkCustomV2 from '../lib/components/NavLinkCustomV2';
import FeedbackModal from '../Feedback/FeedbackModal';
import './More.css';

const More = ({ userData, isLoggedIn }) => {
    const linkCategories = [
        {
            title: "League Information",
            icon: "bi-info-circle",
            links: [
                { route: "/league", text: "Rosters", icon: "bi-people-fill" },
                { route: "/draft", text: "Draft Central", icon: "bi-list" },
                { route: "/history", text: "League History", icon: "bi-clock-history" },
                { route: "/rules", text: "Rules", icon: "bi-book" },
                { route: "/players", text: "Players", icon: "bi-person-badge" },
                { route: "/trades", text: "Trade History", icon: "bi-arrow-left-right" },
                { route: "/transactions", text: "Transactions", icon: "bi-list-check" }
            ]
        },
        {
            title: "Live Updates",
            icon: "bi-graph-up",
            links: [
                { route: "/scoreboard", text: "Scoreboard", icon: "bi-graph-up" },
                { route: "/standings", text: "Standings & Power Rankings", icon: "bi-trophy" },
                { route: "/draftLobby", text: "Live Draft", icon: "bi-controller" }
            ]
        },
        {
            title: "User Actions",
            icon: "bi-person-gear",
            links: isLoggedIn ? [
                { route: "/trade", text: "Make Trade", icon: "bi-handshake" },
                { route: "/user", text: "Profile", icon: "bi-person-circle" },
                ...(userData.permissions ? [{ modal: "#feedbackModal", text: "Send Feedback", icon: "bi-chat-square-text" }] : [])
            ] : [
                { route: "/login", text: "Login", icon: "bi-box-arrow-in-right" },
                { route: "/signup", text: "Sign Up", icon: "bi-person-plus" }
            ]
        }
    ];

    // Add admin category if user has admin permissions
    if (userData.permissions === 'admin') {
        linkCategories.push({
            title: "Admin Tools",
            icon: "bi-gear-fill",
            links: [
                { route: "/admin", text: "Admin Dashboard", icon: "bi-speedometer2" },
                { route: "/admin/trade", text: "Admin Make Trade", icon: "bi-tools" }
            ]
        });
    }

    return (
        <div className="more-container">
            <div className="more-header">
                <h2>
                    <i className="bi bi-three-dots-vertical me-2"></i>
                    More
                </h2>
                <p className="more-subtitle">Quick access to all league features</p>
            </div>
            
            <div className="more-sections">
                {linkCategories.map((category, index) => (
                    <div key={index} className="more-section">
                        <div className="section-header">
                            <i className={`bi ${category.icon} me-2`}></i>
                            <h4>{category.title}</h4>
                        </div>
                        <div className="links-grid">
                            {category.links.map((link, linkIndex) => {
                                const content = (
                                    <div className="link-content">
                                        <i className={`bi ${link.icon} link-icon`}></i>
                                        <span className="link-text">{link.text}</span>
                                        <i className="bi bi-chevron-right link-arrow"></i>
                                    </div>
                                );
                                return (
                                    <div key={linkIndex} className="link-card">
                                        {link.modal ? (
                                            <button
                                                type="button"
                                                className="btn p-0 w-100 text-start"
                                                data-bs-toggle="modal"
                                                data-bs-target={link.modal}
                                            >
                                                {content}
                                            </button>
                                        ) : (
                                            <NavLinkCustomV2 route={link.route} text={content} />
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
            {userData.permissions && <FeedbackModal />}
        </div>
    );
};

export default More;